import { buildBase, DASHBOARD_BASE } from "./constants";

const BASE = buildBase("account");

export const ACCOUNT_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */

  // Organizer Section
  const ORGANIZATION_ROOT = `${DASHBOARD_BASE}/organization`;
  const ORGANIZATION = {
    ROOT: ORGANIZATION_ROOT,
    GENERAL: `${ORGANIZATION_ROOT}/general`,
    CONTACT: `${ORGANIZATION_ROOT}/contact`,
    SCHEDULE: `${ORGANIZATION_ROOT}/schedule`,
    LEGAL: `${ORGANIZATION_ROOT}/legal`,
    SUBORGANIZATIONS: `${ORGANIZATION_ROOT}/suborganizations`,
  };

  const BRANDING_ROOT = `${DASHBOARD_BASE}/branding`;
  const BRANDING_EMAILS_ROOT = `${BRANDING_ROOT}/emails`;
  const BRANDING = {
    ROOT: BRANDING_ROOT,
    IDENTITY: `${BRANDING_ROOT}/identity`,
    PROFILE: `${BRANDING_ROOT}/profile`,
    MESSAGING: `${BRANDING_ROOT}/messaging`,
    EMAILS: {
      ROOT: BRANDING_EMAILS_ROOT,
      SENDER: `${BRANDING_EMAILS_ROOT}/sender`,
      CUSTOMIZATION: `${BRANDING_EMAILS_ROOT}/customization`,
      POST_EVENT: `${BRANDING_EMAILS_ROOT}/post-event`,
    },
    DIGITAL_WALLETS: `${BRANDING_ROOT}/digital-wallets`,
    // Legacy route (redirect to EMAILS.CUSTOMIZATION)
    EMAIL_CUSTOMIZATION: `${BRANDING_EMAILS_ROOT}/customization`,
  };

  const DOMAINS_ROOT = `${DASHBOARD_BASE}/domains`;
  const DOMAINS = {
    ROOT: DOMAINS_ROOT,
    ADD: `${DOMAINS_ROOT}/add`,
    detail: (id: string) => `${DOMAINS_ROOT}/${id}`,
    verification: (id: string) => `${DOMAINS_ROOT}/${id}`,
    website: (id: string) => `${DOMAINS_ROOT}/${id}/website`,
    delete: (id: string) => `${DOMAINS_ROOT}/${id}/delete`,
  };

  const WEBSITES_ROOT = `${DASHBOARD_BASE}/websites`;
  const WEBSITES = {
    ROOT: WEBSITES_ROOT,
    CREATE: `${WEBSITES_ROOT}/create`,
    detail: (slug: string) => `${WEBSITES_ROOT}/${slug}`,
    settings: (slug: string) => `${WEBSITES_ROOT}/${slug}/settings`,
    domain: (slug: string) => `${WEBSITES_ROOT}/${slug}/domain`,
    branding: (slug: string) => `${WEBSITES_ROOT}/${slug}/branding`,
    pages: (slug: string) => `${WEBSITES_ROOT}/${slug}/pages`,
    pageEdit: (websiteSlug: string, pageSlug: string) =>
      `${WEBSITES_ROOT}/${websiteSlug}/pages/${pageSlug}/edit`,
    pageSettings: (websiteSlug: string, pageSlug: string) =>
      `${WEBSITES_ROOT}/${websiteSlug}/pages/${pageSlug}/settings`,
    headerEdit: (slug: string) => `${WEBSITES_ROOT}/${slug}/header/edit`,
    footerEdit: (slug: string) => `${WEBSITES_ROOT}/${slug}/footer/edit`,
  };

  const MODULES_ROOT = `${DASHBOARD_BASE}/modules`;
  const MODULES = {
    ROOT: MODULES_ROOT,
  };

  const INTEGRATIONS_ROOT = `${DASHBOARD_BASE}/integrations`;
  const INTEGRATIONS = {
    ROOT: INTEGRATIONS_ROOT,
    INSTALLED: `${INTEGRATIONS_ROOT}/installed`,
    DEVELOPER: `${INTEGRATIONS_ROOT}/developer`,
    app: (slug: string) => `${INTEGRATIONS_ROOT}/apps/${slug}`,
    installedApp: (slug: string) => `${INTEGRATIONS_ROOT}/installed/${slug}`,
  };

  const TEAM_ROOT = `${DASHBOARD_BASE}/team`;
  const TEAM = {
    ROOT: TEAM_ROOT,
    EMPLOYEES: `${TEAM_ROOT}/employees`,
    ROLES: `${TEAM_ROOT}/roles`,
    PERMISSIONS: `${TEAM_ROOT}/permissions`,
    employee: (id: string) => `${TEAM_ROOT}/employees/${id}`,
  };

  // My Settings Section
  const MY_SETTINGS_ROOT = `${DASHBOARD_BASE}/my-settings`;
  const MY_SETTINGS = {
    ROOT: MY_SETTINGS_ROOT,
    ACCESS_PIN: `${MY_SETTINGS_ROOT}/access-pin`,
    PROFILE: `${MY_SETTINGS_ROOT}/profile`,
    NOTIFICATIONS: `${MY_SETTINGS_ROOT}/notifications`,
  };

  // Financial Section
  const FINANCIALS_ROOT = `${DASHBOARD_BASE}/financials`;
  const FINANCIALS = {
    ROOT: FINANCIALS_ROOT,
    FEE_SETTINGS: `${FINANCIALS_ROOT}/fee-settings`,
    PAYMENT_INFO: `${FINANCIALS_ROOT}/payment-info`,
    PLAN_AND_PRICING: `${FINANCIALS_ROOT}/plan-and-pricing`,
    INTERNAL_FEES: `${FINANCIALS_ROOT}/internal-fees`,
  };

  // Legacy Webhooks (kept for backwards compatibility, will be under Integrations > Developer)
  const WEBHOOKS_ROOT = `${DASHBOARD_BASE}/webhooks`;
  const WEBHOOKS = {
    ROOT: WEBHOOKS_ROOT,
    EVENTS: `${WEBHOOKS_ROOT}/events`,
    LOGS: `${WEBHOOKS_ROOT}/logs`,
    CREATE: `${WEBHOOKS_ROOT}/create`,
    endpoint: (id: string) => `${WEBHOOKS_ROOT}/${id}`,
    eventDetail: (uuid: string) => `${WEBHOOKS_ROOT}/events/${uuid}`,
  };

  return {
    ...basicRoutes,
    // Organizer
    ORGANIZATION,
    BRANDING,
    DOMAINS,
    WEBSITES,
    MODULES,
    INTEGRATIONS,
    TEAM,
    // My Settings
    MY_SETTINGS,
    // Financial
    FINANCIALS,
    // Legacy (for backwards compatibility)
    WEBHOOKS,
    ACCESS_PIN: MY_SETTINGS.ACCESS_PIN,
    PLAN_AND_PRICING: FINANCIALS.PLAN_AND_PRICING,
    INTERNAL_FEES: FINANCIALS.INTERNAL_FEES,
  };
})();
